import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { useCurrentWorkspace } from '@gripp/shared-logic';
import { Colors } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { CreateAddonForm } from './createAddonForm';

export const CreateAddonButton = () => {
  const { t } = useTranslation();
  const currentWorkspace = useCurrentWorkspace();

  return (
    currentWorkspace && (
      <View style={styles.createAddonContainer}>
        <ModalButton
          label=""
          customButton={
            <View style={styles.createAddonButton}>
              <MaterialCommunityIcons
                name="plus"
                color={Colors.role.textPrimary}
                size={16}
                style={styles.icon}
              />
              <Text style={styles.label}>{t('addOn.create.label')}</Text>
            </View>
          }
          buttonStyle={styles.createAddonButton}
          modalComponent={({ onComplete }) => {
            return (
              <CreateAddonForm
                onComplete={onComplete}
                workspaceId={currentWorkspace.id}
              />
            );
          }}
          containerStyle={styles.modalContainer}
        />
      </View>
    )
  );
};

const styles = StyleSheet.create({
  createAddonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,
  },
  createAddonButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 151,
    height: 32,
    backgroundColor: Colors.role.surface,
    borderRadius: 16,
  },
  icon: {
    marginRight: 4,
  },
  label: {
    fontSize: 16,
    fontWeight: '500',
    letterSpacing: -0.25,
    color: Colors.role.textPrimary,
  },
  modalContainer: {
    flex: 1,
    alignSelf: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 560,
    maxHeight: 193,
    borderRadius: 12,
    backgroundColor: Colors.role.surfaceHover,
    overflow: 'hidden',
  },
});
